<template>
  <ul class="plans-list">
    <li
      v-for="plan in plans.list"
      :class="['plan-' + plan.id, {available: available(plan), view: view}]"
      @click="choose(plan)"
      >
      <h4>
        {{ plan.name | text }}
      </h4>
      <div class="price">
        <Cell :item=plan :field=priceField :name=priceFieldName />
      </div>
      <p>{{ plan.description | text }}</p>
      <button @click.stop="viewing = !viewing && plan.id">
        {{ 'buttons.show' | trans }}
      </button>
      <a
        v-if="clickable"
        @click="choose(plan)" :disabled="current && current.id === plan.id"
        :title="tooltip(plan)"
      >
        <span v-if="current && current.id === plan.id">{{ tooltip(plan) }}</span>
        <Icon v-else-if="plan.id===value" name="tick" />
        <span v-else>&nbsp;</span>
      </a>
      <label v-else>
        <span v-if="current && current.id === plan.id">{{ tooltip(plan) }}</span>
        <span v-else>&nbsp;</span>
      </label>
      <Wizard class="sm" v-if="viewing === plan.id" :logo=false>
        <PlanOverview class="details" :plan=plan />
        <a class="close" v-close @click.stop="viewing=null"></a>
      </Wizard>
    </li>
  </ul>
</template>

<script>
  import Cell from '@/helpers/components/display/Cell'
  import Wizard from '@/helpers/components/display/Wizard'
  import PlanOverview from './PlanOverview'

  import {billings_plans as fields} from '../fields'

  export default {
    name: 'BillingPlans',
    components: {Cell, PlanOverview, Wizard},
    props: {
      plans:{},
      current:{},
      value:{},
      view: {default: false},
      cycle: {default: 'monthly'},
    },
    data () {return {
      viewing: null,
      clickable: typeof this.value !== 'undefined',
    }},
    computed: {
      priceFieldName () {return 'prices_subscription_' + this.cycle;},
      priceField () {return fields[this.priceFieldName];},
    },
    methods: {
      tooltip (plan) {
        if (!this.current || this.current.id > plan.id) {
          return this.$t('billings:plans.switch_to');
        }
        if (this.current.id === plan.id) {
          return this.$t('billings:plans.current');
        }
        if (this.current.id < plan.id) {
          return this.$t('billings:plans.upgrade_to');
        }
      },
      choose (plan) {
        if (this.view) {
          this.viewing = !this.viewing && plan.id;
        }
        if (this.available(plan)) {
          this.$emit('input', plan.id);
        }
      },
      available (plan) {
        return (!this.current || this.current.id !== plan.id) && this.clickable;
      },
    },
  }
</script>

<style lang="scss" scoped>
  @mixin plan-color($color) {
    > h4, > button {
      background-color: $color;
    }
    > * {
      border-color: $color;
      transition: background .2s;
    }
    > label, > a {
      color: $color;
    }
    &.available:hover {
      > button {
        background: rgba($color, .8);
      }
      > a, > .price, p {
        background: rgba($color, .2);
      }
    }
  }

  .plans-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: stretch;
    > li {
      display: flex;
      align-items: stretch;
      flex-direction: column;
      &.available, &.view {
        cursor: pointer;
      }
      > * {
        flex-grow: 0;
      }
      > p {
        flex-grow: 1;
        margin: 0;
      }
      text-align: center;
      flex-basis: $plan-width;
      margin: 0 15px 30px;
      @media (max-width: $xs-max) {
        margin: 0 0 30px;
      }
      @include plan-color($accent);
      @each $id, $color in $plan-colors {
        &.#{'plan-' + $id} {
          @include plan-color($color);
        }
      }
      > h4 {
        color: white;
        font-weight: 400;
        letter-spacing: 0.025em;
        text-transform: capitalize;
        @include font-size(22px, 28px);
        padding: 3px 6px;
      }
      > .price {
        font-weight: 700;
        @include font-size(22px);
        >>> dt {
          display: block;
          font-size: 20px;
          font-weight: 400;
          &::after {
            content: none;
          }
        }
      }
      > .price, > p {
        border-style: solid;
        border-width: 0 2px 2px 2px;
        padding: 15px 23px;
      }
      > button {
        margin: 10px 0;
        color: white;
        font-size: 18px;
      }
      > label, > a {
        padding: 10px;
        height: 70px;
        overflow: hidden;
        line-height: 46px;
        font-size: 44px;
        border: solid 2px;
        > span {
          display: block;
          @include font-size(20px);
        }
      }
      > a {
        cursor: pointer;
        &[disabled] {
          cursor: default;
          opacity: .4;
        }
      }
    }
    .details {

    }
  }
</style>



// WEBPACK FOOTER //
// src/sections/billings/components/BillingPlans.vue